import { DeviceRestrictionType } from '@models/section';

export function cleanSectionName(sectionName: string): string {
    return sectionName
        .split('-')
        .map((word) => word[0].toUpperCase() + word.substring(1))
        .join('');
}

export function shouldShowSection(isMobile: boolean, deviceRestrictionType?: DeviceRestrictionType): boolean {
    return (
        !deviceRestrictionType ||
        deviceRestrictionType === 'none' ||
        (deviceRestrictionType === 'desktopOnly' && !isMobile) ||
        (deviceRestrictionType === 'mobileOnly' && isMobile)
    );
}
